/**
 * @author PoornaChandu
 * @description This Component is mainly for Creating Jobplans and Task
 * @View Table with crud operations of Task
 */
import moment from 'moment';
import './../CSS/style.css';
import { connect } from 'react-redux';
import React, { useState, useEffect, useCallback } from 'react';
import StyledTable from '../../../commons/styles/table';
import {
  Button,
  Input,
  Popconfirm,
  Tooltip,
  Divider,
  Space,
  Card,
  Pagination,
  Select,
  Empty
} from 'antd';
import {
  EditOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
  UserOutlined,
  AuditOutlined,
  CalendarOutlined,
  AppstoreOutlined,
  UnorderedListOutlined,
  PlusOutlined
} from '@ant-design/icons';
import {
  getUsecaseList,
  deleteUsecase,
  getUserListData,
  getSitesList
} from '../APICalls/FormCalls';
const Analytics = (props) => {
  //const [Columns, setColumns] = useState([]);
  const [dataSource, setDataSource] = useState([]);
  // const [activeKey, setActiveKey] = useState('1');
  // const [form, setForm] = useState({});
  //const [ellipsis, setEllipsis] = useState(true);
  const [userProfile, setUserProfile] = useState(props.userProfile || {});
  const [userList, setUserList] = useState([]);
  const [searchField, setSearchField] = useState('');
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [filterKey, setFilterKey] = useState(null);
  const [viewType, setViewType] = useState('table');
  //const [usernameFiltered, setUsernameFiltered] = useState('');
  const [SiteList, setSiteList] = useState([]);
  const [selectedSortKey, setSelectedSortKey] = useState('');
 const FirstName = {};
  const _getUserList = useCallback(async () => {
    const userList = await getUserListData();
    setUserList(userList);
  }, []);
  const _getAdhocDataSource = useCallback(async () => {
    const dataSource = await getUsecaseList('both');
    setDataSource(dataSource);
    // setActiveKey('1');
    // setForm({});
    setSearchField('');
  }, []);
  useEffect(() => {
    _getAdhocDataSource();
    _getUserList();
    const fetchSitesList = async () => {
      const siteList = await getSitesList();
      setSiteList(siteList);
    };
    fetchSitesList();
  }, [_getAdhocDataSource, _getUserList]);
  useEffect(() => {
    if (props.userProfile !== userProfile) {
      setUserProfile(props.userProfile);
    }
  }, [props.userProfile, userProfile]);
  const filterByValue = (value) => {
    let SearchedDate = null;
    const formats = ['DD-MM-YYYY', 'MM-DD-YYYY', 'YYYY-MM-DD'];
    if (filterKey === 'User Id') {
      return dataSource.filter((o) => {
        return o.FirstName.toString().toLowerCase().includes(value.toString().toLowerCase());
      });
    } else if (filterKey === 'SiteId') {
      return dataSource.filter((o) => {
        return o.Name.toString().toLowerCase().includes(value.toString().toLowerCase());
      });
    } else if (filterKey === 'CreatedDate') {
      for (const format of formats) {
        const momentObj = moment(value, format, true);
        if (momentObj.isValid()) {
          SearchedDate = momentObj.toDate();
          break;
        }
      }
      if (SearchedDate !== null) {
        return dataSource.filter((o) => {
          const date = new Date(o.CreatedDate);
          return (
            date.getDate() === SearchedDate.getDate() &&
            date.getMonth() === SearchedDate.getMonth() &&
            date.getFullYear() === SearchedDate.getFullYear()
          );
        });
      }
    } else {
      return dataSource.filter((o) => {
        return o && o[filterKey] && o[filterKey].toString().toLowerCase().includes(value.toString().toLowerCase());
      });
    }
  };
  const onSearch = (value) => {
    const filteredDataSource = filterByValue(value);
    setDataSource(filteredDataSource);
  };
  const sortDate = (e) => {
    const sortedDataSource = [...dataSource];
    if (selectedSortKey === 'CreatedDate') {
      sortedDataSource.sort((a, b) => e === 'ascending' ? a.CreatedDate.localeCompare(b.CreatedDate) : b.CreatedDate.localeCompare(a.CreatedDate));
    } else if (selectedSortKey === 'CreatedBy') {
      const newArray = sortedDataSource.map((Obj) => {
        const matchingObj = userList.find((item) => item.Id === Obj.UserId);
        return matchingObj ? { ...Obj, FirstName: matchingObj.FirstName } : Obj;
      });
      newArray.sort((a, b) => a.FirstName.localeCompare(b.FirstName));
      return newArray;
    }
    setDataSource(sortedDataSource);
  };
  const DeleteUsecase = async (id) => {
    await deleteUsecase (id);
    const updatedDataSource = await getUsecaseList();
    setDataSource(updatedDataSource);
    // setActiveKey('1');
  };
  const editUsecase = (id) => {
    props.navigate(`/rubus/RbsAnalytics/UseCaseDetails/${id}`);
  };
  const add3Dots = (text, limit) => {
    return text.length > limit ? text.substring(0, limit) + '...' : text;
  };
  const onPaginationChange = (current, pageSize) => {
    setCurrent(current);
    setPageSize(pageSize);
  };
  const onViewTypeChange = (viewType) => {
    setViewType(viewType);
  };
  const onhandleChange = (e) => {
    setFilterKey(e);
    if (e === 'User Id') {
      const newArray = dataSource.map((obj1) => {
        const obj2 = userList.find((obj2) => obj2.Id === obj1.UserId);
        return { ...obj1, FirstName: obj2.FirstName };
      });
      setDataSource(newArray);
    } else if (e === 'SiteId') {
      const siteArray = dataSource.map((obj1) => {
        const obj2 = SiteList.find((obj2) => obj2.Id === obj1.SiteId);
        return { ...obj1, Name: obj2.Name };
      });
      setDataSource(siteArray);
    }
  };
  const IconText = ({ icon, text }) => (
    <Space>
      {React.createElement(icon)}
      {text}
    </Space>
  );
  const columns = [
    {
      title: 'Usecase',
      dataIndex: 'UseCaseName',
      key: 'UseCaseName',
      align: 'center',
      width: '40%'
    },
    {
      title: 'Description',
      dataIndex: 'Description',
      key: 'Description',
      align: 'center',
      width: '40%'
    },
    {
      title: 'Action',
      align: 'center',
      render: (text, record) => (
        <>
          <Button
            type='primary'
            onClick={() => editUsecase(record.Id)}
            
          >
            <EditOutlined />
          </Button>
          <Popconfirm
            title="Are you sure that you want to delete the Usecase"
            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
            onConfirm={() => DeleteUsecase(record.Id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type='primary'  style={{ marginLeft: '20px' }}>
              <DeleteOutlined />
            </Button>
          </Popconfirm>
        </>
      )
    }
  ];
  const data = dataSource.map((i) => ({
    title: i.Title,
    avatar: (
      <AuditOutlined
        style={{
          backgroundColor: '#fff',
          color: '#1a4c7e',
          padding: '6px'
        }}
      />
    ),
    content: i.UseCaseName,
    Id: i.Id,
    UserId: i.UserId,
    CreatedDate: i.CreatedDate
  }));
  return (
    <>
      <>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ padding: '5px' }}>
            <Select
              className="selectFilter"
              showSearch
              placeholder="Select Attribute"
              allowClear
              value={filterKey}
              style={{
                background: '#1a3652',
                borderRight: 'none',
                borderTop: 'none',
                borderLeft: 'none',
                width: '20%',
                margin: '2px',
                padding: '0px'
              }}
              onChange={onhandleChange}
            >
              <Select.Option key="Title">Title</Select.Option>
              <Select.Option key="Description">Description</Select.Option>
              <Select.Option key="SiteId">Site</Select.Option>
              <Select.Option key="User Id">CreatedBy</Select.Option>
              <Select.Option key="CreatedDate">CreatedDate</Select.Option>
            </Select>
            <Input
              type="text"
              className="searchInput"
              style={{
                background: 'rgb(255, 255, 255)',
                borderRight: 'none',
                borderTop: 'none',
                color: 'black',
                borderLeft: 'none',
                width: '20%',
                padding: '5px'
              }}
              id="searchText"
              value={searchField}
              onChange={(e) => setSearchField(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  onSearch(searchField);
                }
              }}
              placeholder="Search"
            />
            <Select
              className="selectFilter"
              showSearch
              placeholder="Sort Attribute "
              allowClear
              style={{
                background: '#1a3652',
                borderRight: 'none',
                borderTop: 'none',
                borderLeft: 'none',
                width: '20%',
                margin: '2px',
                padding: '0px'
              }}
              onChange={setSelectedSortKey}
            >
              <Select.Option key="CreatedBy">CreatedBy</Select.Option>
              <Select.Option key="CreatedDate">CreatedDate</Select.Option>
            </Select>
            <Select
              className="selectFilter"
              showSearch
              placeholder="Select Sort Attribute "
              allowClear
              style={{
                background: '#1a3652',
                borderRight: 'none',
                borderTop: 'none',
                borderLeft: 'none',
                width: '20%',
                margin: '2px',
                padding: '0px'
              }}
              onChange={sortDate}
            >
              {selectedSortKey === 'CreatedDate' ? (
                <>
                  <Select.Option key="ascending">Ascending</Select.Option>
                  <Select.Option key="descending">Descending</Select.Option>
                </>
              ) : (
                <Select.Option key="Alpa">sort</Select.Option>
              )}
            </Select>
          </div>
          <div style={{ marginTop: '9px' }}>
            <PlusOutlined
              onClick={() => props.navigate(`/rubus/RbsAnalytics/UseCaseDetails/new`)}
              style={{
                
                color: viewType === 'table' ? 'rgb(255, 108, 0)' : '#dfa230',
                marginLeft: '10px'
              }}
            />
            <UnorderedListOutlined
              onClick={() => onViewTypeChange('table')}
              style={{
                
                color: viewType === 'table' ? 'rgb(255, 108, 0)' : '#dfa230',
                marginLeft: '10px'
              }}
            />
            <AppstoreOutlined
              onClick={() => onViewTypeChange('card')}
              style={{
                
                color: viewType === 'card' ? 'rgb(255, 108, 0)' : '#dfa230',
                marginLeft: '10px'
              }}
            />
          </div>
        </div>
        <div style={{ marginTop: '10px' }}>
          {viewType === 'card' ? (
            <div>
              {data && Array.isArray(data) && data.length !== 0 ? (
                <div className="ListDataView" style={{ display: 'flex', flexWrap: 'wrap' }}>
                  {data
                    .filter((_, index) => index >= pageSize * current - pageSize && index < pageSize * current)
                    .map((useCase) => {
                      const userName = userList.find((e) => e.Id === useCase.UserId);
                      return (
                        <Card
                          key={useCase.title}
                          style={{
                            width: '410px',
                            padding: '5px',
                            margin: '5px'
                          }}
                        >
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div style={{ padding: '0px 0px 6px 0px',  fontWeight: 'bolder', color: '#d98e04' }}>
                              {add3Dots(useCase.title, 35)}
                            </div>
                            <div style={{ margin: '0px 0px 7px 0px' }}>
                              <IconText
                                icon={UserOutlined}
                                text={userName ? userName.FirstName : FirstName || ''}
                                key="list-vertical-star-o"
                              />
                            </div>
                            <div style={{ margin: '0px 0px 7px 0px' }}>
                              <IconText
                                icon={CalendarOutlined}
                                text={moment(useCase.CreatedDate).format('DD-MM-YYYY HH:mm:ss')}
                                key="list-vertical-like-o"
                              />
                            </div>
                          </div>
                          <Divider className="customDividerHor" style={{ borderTop: '1px solid #000', height: '0px' }} />
                          <div style={{ display: 'flex', flexDirection: 'row', margin: '0px 0px' }}>
                            <Tooltip placement="top" key="Edit" title="Edit">
                              <EditOutlined
                                style={{ color: '#d98e04', marginRight: '8px' }}
                                onClick={() => editUsecase(useCase.Id)}
                              />
                            </Tooltip>
                            <Divider type="vertical" />
                            <Popconfirm
                              key="1"
                              title="Are you sure that you want to delete the Usecase"
                              icon={<QuestionCircleOutlined style={{ color: '#d98e04' }} />}
                              onConfirm={() => DeleteUsecase(useCase.Id)}
                              okText="Yes"
                              cancelText="No"
                            >
                              <Tooltip placement="top" key="Delete" title="Delete">
                                <DeleteOutlined
                                  style={{ color: '#d98e04', marginRight: '8px' }}
                                />
                              </Tooltip>
                            </Popconfirm>
                          </div>
                        </Card>
                      );
                    })}
                </div>
              ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              )}
              {data && Array.isArray(data) && data.length !== 0 && data.length ? (
                <div style={{ display: 'flex', flexDirection: 'row', margin: '14px' }}>
                  <Pagination
                    current={current}
                    onChange={onPaginationChange}
                    total={data.length}
                    pageSize={10}
                  />
                </div>
              ) : null}
            </div>
          ) : (
            <StyledTable size="small"
              dataSource={Array.isArray(dataSource) ? dataSource.map((data, index) => ({ ...data, key: index })) : []}
              columns={columns}
            />
          )}
        </div>
      </>
    </>
  );
};
const mapStateToProps = (state) => ({
  userProfile: state.LayoutReducer.loggedInProfile
});
export default connect(mapStateToProps)(Analytics);